import { render } from "./StatisticsPortal.vue?vue&type=template&id=7b5e1f66&scoped=true&ts=true"
import script from "./StatisticsPortal.vue?vue&type=script&lang=ts"
export * from "./StatisticsPortal.vue?vue&type=script&lang=ts"

import "./StatisticsPortal.vue?vue&type=style&index=0&id=7b5e1f66&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b5e1f66"]])

export default __exports__